export default __webpack_public_path__ + "static/media/1_0140.c29441a5.webp";